module.exports = __webpack_public_path__ + "abb84645c75c657641b35e2c975d5210.svg";